<script>
  // eslint-disable-next-line  @ObamaFoundation/of-svelte/no-stores
  import { navigating } from "$app/stores";
  import FullWidth from "$lib/components/MenuTypes/FullWidth/FullWidth.svelte";
  import Static from "$lib/components/MenuTypes/Static/Static.svelte";
  import Section from "$lib/components/MenuTypes/Section.svelte";
  import Dropdown from "$lib/components/MenuTypes/Dropdown/Dropdown.svelte";
  import IconList from "$lib/components/MenuTypes/IconList.svelte";
  import JumpLinks from "$lib/components/MenuTypes/JumpLinks.svelte";

  export const MENU_TYPE_MAP = {
    "Full Width Menu": FullWidth,
    "Column (static)": Static,
    Dropdown,
    Flyout: Static,
    "Flyout (w/descriptions)": Static,
    "Icon List": IconList,
    "Jump Links": JumpLinks,
    "Select Menu": Static,
    "Simple Menu (Icon Trigger)": Static,
    Section
  };

  export let data;

  export let isOpen = false;

  function toggle(e) {
    e.preventDefault();
    isOpen = !isOpen;
  }
  function close() {
    isOpen = false;
  }
  $: $navigating && close();
  let menuContainer = MENU_TYPE_MAP[data.fields.type];
</script>

<svelte:component this={menuContainer} {data} on:click={toggle} {isOpen} />
